var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.params)?_c('div',[_c('GraphView',{attrs:{"chartOptions":_vm.params}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }